import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon } from 'lucide-react';
export function Proof() {
  return <section className="py-24 bg-dark relative" data-id="element-236">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="glass-panel p-8 md:p-12 rounded-sm relative overflow-hidden" data-id="element-238">
          <div className="absolute top-0 right-0 p-8 opacity-5" data-id="element-239">
            <ActivityIcon className="w-64 h-64 text-primary" data-id="element-240" />
          </div>

          <div className="relative z-10" data-id="element-241">
            <h2 className="font-display text-2xl md:text-3xl font-extrabold text-white mb-6 uppercase tracking-wide" data-id="element-242">
              La diferencia entre el <span className="text-danger" data-id="element-243">caos</span> y
              el <span className="text-primary" data-id="element-244">control</span>
            </h2>

            <div className="space-y-6 text-lg text-gray-300 font-light leading-relaxed" data-id="element-245">
              <p data-id="element-246">
                En solo{' '}
                <strong className="text-secondary font-bold" data-id="element-247">7 días</strong>{' '}
                integrando el Sniper Panel, la psicología del operador cambia.
                Ya no hay sudor en las manos ni dudas al entrar.
              </p>
              <p data-id="element-248">
                El sistema te obliga a ser profesional. Pasas de{' '}
                <span className="italic text-gray-400" data-id="element-249">"ver qué pasa"</span> a{' '}
                <strong className="text-primary font-bold text-glow" data-id="element-250">
                  "ejecutar lo que toca"
                </strong>
                .
              </p>
            </div>

            <div className="mt-10 flex items-center gap-4" data-id="element-251">
              <div className="flex -space-x-4" data-id="element-252">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-12 h-12 rounded-full bg-surfaceHighlight border-2 border-dark flex items-center justify-center overflow-hidden" data-id="element-253">
                    <div className="w-full h-full bg-gradient-to-br from-gray-700 to-gray-900" data-id="element-254"></div>
                  </div>)}
              </div>
              <div className="text-sm text-gray-400" data-id="element-255">
                <span className="text-white font-bold block" data-id="element-256">
                  Traders fondeados
                </span>
                operando con precisión
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}